import React, {Component} from "react";
import {connect} from "react-redux";
import {Route, Switch} from "react-router-dom";

import Create from './create';
import {
  exportOrgData,
  fetchExportedOrgData,
  fetchOrganisation,
  updateOrganisation,
} from "../../appRedux/actions/Setting";
import DataManage from "./data";
import settings from "../../appRedux/reducers/Settings";

// import {fetchFilter} from '../../appRedux/actions';

export class Setting extends Component {
  initialQueryState = {
    sort: {
      field: '',
      order: ''
    },
    pagination: {
      pageSize: 10,
      current: 1
    },
    filters: {},
  };

  state = {
    fields: {
      name: {
        value: '',
      }
    },
    query: this.initialQueryState,
    columns: [],
    visibleColumns: []
  };

  constructor(props) {
    super(props);
    // props.saveResourceQuery(this.initialQueryState);
  }

  componentDidMount() {
    // this.fetchList();
    // this.props.fetchFilter(this.props.resourceName);
    // console.log(this.props.authUser);
  }

  componentWillReceiveProps(nextProps) {
  }

  handleFormChange = (changedFields) => {
    this.setState(({fields}) => ({
      fields: {...fields, ...changedFields},
    }));
  };

  updateResource = (values, id) => {
    this.props.updateOrganisation(values, id);
  };

  render() {
    const {match, data, resource, edit, fetchResource, loading, filters, modules, authUser, resourceName} = this.props;

    return (<div>
      <h2>Organisation Setting</h2>

      <Switch>
        <Route path={`${match.url}`} exact
               render={() => <Create data={edit}
                                     filters={filters}
                                     modules={modules}
                                     title={'EDIT'}
                                     authUser={authUser}
                                     resource={resourceName}
                                     fetch={this.props.fetchOrganisation}
                                     onChange={this.handleFormChange}
                                     onSubmit={this.updateResource}
                                     loading={loading}
               />
               }/>
        <Route path={`${match.url}/data`}
               render={() => <DataManage exportOrgData={this.props.exportOrgData}
                                         exportedData={this.props.exportedData}
                                         fetchExportedOrgData={this.props.fetchExportedOrgData}
                                         loading={loading}
               />
               }/>
      </Switch>
    </div>)
  }
}

const mapStateToProps = ({auth, organisation, commonData, settings}) => {
  return {
    authUser: auth.authUser,
    data: organisation.resources,
    resource: organisation.resource,
    edit: organisation.edit,
    query: organisation.query,
    loading: commonData.loading,
    filters: commonData.filters,
    modules: commonData.modules,
    exportedData: settings.exportedData,
  }
};

function mapDispatchToProps(dispatch) {
  return {
    fetchOrganisation,
    updateOrganisation,
    exportOrgData,
    fetchExportedOrgData,
    // fetchFilter
  };
}

export default connect(mapStateToProps, mapDispatchToProps())(Setting);
